if (typeof countUp !== 'undefined') {
	$('.stat p:first-child').each((i, el) => {
		const $this = $(el);

		// First, replace any commas
		$this.text($this.text().replace(/\,/g, ''));

		// Next wrap numbers in span
		$this.html($this.text().replace(/(\d+)(.?)$/g, `<span class="number">$1</span>$2`));

		// Init count up library
		const statCounter = new countUp.CountUp($this.find('.number').get(0), $this.find('.number').text(), {
			separator: ',',
			enableScrollSpy: true,
			scrollSpyDelay: i * 200,
			scrollSpyOnce: true,
		});
	});
}
